module.exports = __webpack_public_path__ + "img/logo-lhs-adidas.5111c0d3.svg";